module.exports = __webpack_public_path__ + "assets/img/24@3x.413c88da.png";